import App from '../../components/App';
import props from '../../configs/propsCursive';

export default function FontGenerator() {
  return <App {...props} />;
}
